import { useModal } from "@ebay/nice-modal-react";
import style from "./MobileAddCartBase.module.css";
import {
    useEffect,
    useState,
    forwardRef,
    useImperativeHandle,
    useCallback,
    useRef,
} from "react";
import MobileAddCartBaseHeader from "./MobileAddCartBaseHeader";
import ModalBaseMain from "./ModalBaseMain";
import MobileAddCartBaseFooter from "./MobileAddCartBaseFooter";
import clsx from "classnames";

const MobileAddCartBase = forwardRef((props, ref) => {
    const modal = useModal();
    const modalContentRef = useRef();
    const [maskHeight, setMaskHeight] = useState(
        Math.max(window.innerHeight, document.documentElement.offsetHeight)
    );
    const { padding, borderRadius } = props;
    const [isClosing, setIsClosing] = useState(false);

    useEffect(() => {
        window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);

    const handleWindowSizeChange = () => {
        setMaskHeight(
            Math.max(window.innerHeight, document.documentElement.offsetHeight)
        );
    };

    const modalClose = () => {
        if (props.slideUp) {
            setIsClosing(true);
            const modalElement = modalContentRef.current;
            const handleAnimationEnd = () => {
                modalElement.removeEventListener("animationend", handleAnimationEnd);
                modal.remove();
            };
            modalElement.addEventListener("animationend", handleAnimationEnd);
        } else {
            modal.remove();
        }
    };

    const onClickOutside = (e) => {
        if (props.clickOutsideToClose && !isClosing) {
            modalClose();
        }
    };

    const insideClickPropagation = (e) => {
        e.stopPropagation();
    };

    const keyFunction = useCallback((event) => {
        if (event.keyCode === 27) {
            modalClose();
        } else if (props.onKeyPress) {
            props.onKeyPress(event);
        }
    }, []);

    useEffect(() => {
        document.addEventListener("keydown", keyFunction);
        return () => {
            document.removeEventListener("keydown", keyFunction);
        };
    }, [keyFunction]);

    useImperativeHandle(ref, () => ({
        close() {
            modalClose();
        },
    }));

    return (
        <div className={style.mask} style={{ height: maskHeight }}>
            <div
                className={style.maskBackground}
                onClick={onClickOutside}
            ></div>
            <div className={style.wrap} style={{ borderRadius: borderRadius }}>
                <div
                    ref={modalContentRef}
                    className={clsx(props.slideUp ? style.slideUpModal : style.modal, {
                        [style.modalSlideDown]: isClosing,
                    })}
                    style={{
                        width: props.width,
                        maxWidth: props.maxWidth,
                        height: props.height,
                        padding: props.padding,
                        borderRadius: props.borderRadius,
                        backgroundColor: props.backgroundColor,
                    }}
                    onClick={insideClickPropagation}
                >
                    {props.withHeader && (
                        <MobileAddCartBaseHeader
                            headerStyle={props.headerStyle}
                            title={props.title}
                            modalClose={modalClose}
                        />
                    )}

                    <div className={style.modalContent}>
                        <ModalBaseMain
                            withCloseButton={
                                props.withHeader || props.withFooter
                                    ? false
                                    : props.withCloseButton
                            }
                            modalClose={modalClose}
                            padding={padding}
                        >
                            {props.children}
                        </ModalBaseMain>
                    </div>

                    {props.withFooter && (
                        <MobileAddCartBaseFooter
                            buttonText={props.buttonText}
                            modalClose={modalClose}
                            onAddCartClick={props.onAddCartClick}
                            onPurchaseClick={props.onPurchaseClick}
                            totalPrice={props.totalPrice}  // totalPrice prop 추가
                        />
                    )}
                </div>
            </div>
        </div>
    );
});

export default MobileAddCartBase;